'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
require('prop-types');
var index_esm = require('../../../node_modules/@date-io/moment/build/index.esm.js');
var ChevronLeft = require('../../../IconsAndImages/Icons/ChevronLeft.js');
var ChevronRight = require('../../../IconsAndImages/Icons/ChevronRight.js');
var Grid = require('../../Layout/Grid/Grid.js');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var TextField = require('../TextFields/TextField.js');
var useUtilsCfb96ac9 = require('../../../node_modules/@material-ui/pickers/esm/useUtils-cfb96ac9.js');
var DatePicker = require('../../../node_modules/@material-ui/pickers/esm/DatePicker.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var DATE_FORMAT = 'MM/DD/YYYY';
var useStyles = makeStyles["default"](function (theme) {
  return {
    datePicker: {
      width: '100%'
    },
    root: {
      backgroundColor: theme.palette.background.main
    }
  };
});

var InlineDatePicker = function InlineDatePicker(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'filled' : _ref$variant,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$dateTitle = _ref.dateTitle,
      dateTitle = _ref$dateTitle === void 0 ? '' : _ref$dateTitle,
      _ref$onDateChange = _ref.onDateChange,
      onDateChange = _ref$onDateChange === void 0 ? function (date, value) {
    return null;
  } : _ref$onDateChange,
      selectedDate = _ref.selectedDate,
      props = objectWithoutProperties(_ref, ["variant", "disabled", "dateTitle", "onDateChange", "selectedDate"]);

  var _useStyles = useStyles(),
      datePicker = _useStyles.datePicker,
      root = _useStyles.root;

  var inputPropsClasses = variant === 'filled' ? {
    root: root
  } : undefined;
  var keyboardButtonProps = variant === 'filled-flat' ? {
    size: 'small'
  } : undefined;
  return React__default["default"].createElement(useUtilsCfb96ac9.M, {
    utils: index_esm
  }, React__default["default"].createElement(Grid, {
    container: true,
    direction: "column"
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: "caption"
  }, dateTitle)), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(DatePicker.KeyboardDatePicker, _extends["default"]({
    disableToolbar: true,
    autoOk: true,
    variant: "inline",
    TextFieldComponent: TextField["default"],
    inputVariant: variant,
    className: datePicker,
    disabled: disabled,
    value: selectedDate,
    onChange: onDateChange,
    format: DATE_FORMAT,
    leftArrowIcon: React__default["default"].createElement(ChevronLeft, null),
    rightArrowIcon: React__default["default"].createElement(ChevronRight, null),
    InputProps: {
      classes: inputPropsClasses
    },
    KeyboardButtonProps: keyboardButtonProps
  }, props)))));
};

module.exports = InlineDatePicker;
